import { Box, Tab, Tabs, Typography } from "@mui/material";
import * as React from "react";
import FarmOnLoan from "./components/farmOnLoan";
import LoanApplicationList from "./components/loanApplicationList";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function LoanPage() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider", pt: 2 }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab
            sx={{
              textTransform: "none",
              fontSize: "18px",
              fontWeight: "500",
              lineHeight: "23.5px",
            }}
            label="Farm on Loan"
            {...a11yProps(0)}
          />
          <Tab
            sx={{
              textTransform: "none",
              fontSize: "18px",
              fontWeight: "500",
              lineHeight: "23.5px",
            }}
            label="Loan Application List"
            {...a11yProps(1)}
          />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <FarmOnLoan />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <LoanApplicationList />
      </CustomTabPanel>
    </Box>
  );
}
